import { getCurrentI18n, transaltionExists } from '../hooks/LanguageHooks';
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';

import { syncRecordFrontEnd } from '../community-hats-js-library/back-end/router';

export const syncRecord = async ({ tableId, behavior, id, fields, searchField = null, searchValue = null }) => {
  const i18n = getCurrentI18n();

  let [code, message, newId, newFields] = await syncRecordFrontEnd({
    tableId,
    behavior,
    id,
    fields,
    searchField,
    searchValue,
  });

  // Uses the i18n object to translate the message
  if (!isNullOrUndefined(message) && transaltionExists(i18n, message)) {
    message = i18n.t(message);
  }

  return [code, message, newId, newFields];
};
